import { ReactNode } from 'react';

import { NavDrawerProvider, SideNav } from 'components/navigation';

export type SideNavLayoutProps = {
    children: ReactNode;
    className?: string;
};

export const SideNavLayout = (props: SideNavLayoutProps) => {

    const { children, className } = props;

    return (
        <NavDrawerProvider>
            <div className="side-nav-layout d-flex h-100 overflow-hidden">
                <SideNav />

                <div
                    className={`side-nav-layout-content flex-fill d-flex flex-column${className ? ` ${className}` : ''}`}
                    style={{ minWidth: 0 }}
                >
                    {children}
                </div>
            </div>
        </NavDrawerProvider>
    );

};